// extracted by mini-css-extract-plugin
export var mt0 = "fp-cw";
export var mt1 = "fp-dw";
export var mt2 = "fp-ew";
export var mt3 = "fp-fw";
export var mt4 = "fp-gw";
export var mt5 = "fp-hw";
export var mt6 = "fp-iw";
export var simpleHeader = "fp-jw";
export var simpleHeader__body = "fp-kw";
export var simpleHeader__logo = "fp-nw";
export var simpleHeader__logoWrapper = "fp-mw";
export var simpleHeader__product = "fp-ow";
export var simpleHeader__wrapper = "fp-lw";